var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';



// WEBPACK FOOTER //
// ./C:/Users/Pili/AppData/Roaming/npm/~/pink/~/core-js/modules/_user-agent.js